// @params message: Hash
// @params setUrl: Function to set a string
export const getMsnUrl = (message, setUrl, setError) => {
  if (!message.mid) {
    setUrl(message.url);
    return;
  }

  let { mid } = message;
  let index = 0;
  const splitedMid = mid.split('___');
  if (splitedMid.length > 1) {
    [mid, index] = splitedMid;
  }
  try {
    // eslint-disable-next-line no-undef
    FB.api( `/${mid}`, 'get', { access_token: ENV.FANPAGE_TOKEN, fields: 'message, attachments' },
      (response) => {
        if (response && !response.error) {
          if (response.attachments
            && response.attachments.data
            && response.attachments.data[index]
            && response.attachments.data[index].image_data) {
            const url = response.attachments.data[index].image_data.url
            setUrl(url);
            setError(false);
          } else if (response.attachments
            && response.attachments.data
            && response.attachments.data[index]
            && response.attachments.data[index].file_url) {
            const url = response.attachments.data[index].file_url
            setUrl(url);
            setError(false);
          } else if (response.attachments
            && response.attachments.data
            && response.attachments.data[index]
            && response.attachments.data[index].video_data) {
            const url = response.attachments.data[index].video_data.url
            setUrl(url);
            setError(false);
          } else {
            setUrl(message.url);
          }
        }
      }
    );
  } catch (e) {
    console.error(e);
  }
};

export const getPostDetails = (post, setMedia, platform) => {
  try {
    const isFacebook = platform === 'facebook_comments' || platform === 'facebook';
    const fields = isFacebook ? 'message,attachments' : 'caption,media_url,media_type';

    // eslint-disable-next-line no-undef
    FB.api( `/${post.post_id}`, 'get', { access_token: ENV.FANPAGE_TOKEN, fields },
      (response) => {
        if (response.error) {
          console.error('FB API Error:', response.error);
          throw new Error(response.error.message);
        }

        let mediaType = response.media_type || '';
        let mediaCaption = response.caption || response.message || '';
        let mediaUrl = response.media_url || '';

        // Fallback to Facebook specific fields if Instagram fields are missing
        if (!mediaType && response.attachments?.data?.[0]) {
          const attachment = response.attachments.data[0];
          if (attachment.type === 'photo' || attachment.type === 'album') {
             mediaType = 'IMAGE';
             mediaUrl = attachment.media?.image?.src || attachment.url;
          } else if (attachment.type === 'video') {
             mediaType = 'VIDEO';
             mediaUrl = attachment.media?.source || attachment.url;
          }
        }

        setMedia({
          type: mediaType,
          caption: mediaCaption,
          url: mediaUrl
        })
      });
    }
    catch (e) {
      setMedia({
        type: '',
        caption: '',
        url: ''
      })
    }
}
